import React, { Component } from 'react';
import './style.css';

export class Footer extends Component {
    state = {
        privacyPolicy: "https://www.pierse.ie/cookies-policy",
        accessibilityStatement: "https://www.pierse.ie/accessibility",
        dataProtectionNotice: "https://www.pierse.ie/data-protection-notice"
    };

    render() {
        const date = new Date();
        var year = date.getFullYear();
        return (
            <div id="footer">
                <div id="footerContent">
                    <a href={this.state.privacyPolicy} aria-label="Cookies & Privacy Policy Link">Cookies & Privacy Policy</a> |
                    <a href={this.state.accessibilityStatement} aria-label="Accessibility Statement Link">Accessibility Statement</a> |
                    <a href={this.state.dataProtectionNotice} aria-label="Data Protection Notice Link">Data Protection Notice</a>
                </div>
                <span>&copy; {year}&nbsp;</span>Pierse Fitzgibbon Solicitors
            </div>
        );
    }
}